export default {
  header: {
    signIn: 'เข้าสู่ระบบ',
    signUp: 'สมัครสมาชิก'
  },
  userMenu: {
    wallet: 'กระเป๋าเงิน',
    withdraw: 'ถอนเงิน',
    transaction: 'ธุรกรรม',
    myBet: 'การเดิมพันของฉัน',
    rollover: 'ยอดหมุนเวียน',
    vault: 'ตู้นิรภัย',
    profile: 'โปรไฟล์',
    settings: 'การตั้งค่า',
    signOut: 'ออกจากระบบ',
    signOutTitle: 'ออกจากระบบ',
    signOutContent: 'สำรวจโลกที่เต็มไปด้วยรางวัลและเกมที่น่าตื่นเต้น!',
    signOutConfirm: 'ออกจากระบบ',
    cancel: 'ยกเลิก'
  }
};
